export const LOGIN_TAB = 'Login'
export const SIGN_UP_TAB = 'Sign Up'

export default { LOGIN_TAB, SIGN_UP_TAB }
